import React, { useEffect, useState } from "react";
import { mountFormattedOverlay } from "../../../../utils/overlaysUtils";
import { NaturalRisks } from "./sections/NaturalRisks";
import { MenuControls } from "./MenuControls";
import { Home } from "./sections/Home";
import { TechnoRisks } from "./sections/TechnoRisks";
import { SocietalRisks } from "./sections/SocietalRisks";
import { SanitaryRisks } from "./sections/SanitaryRisks";
import { Modal } from "./Modal";
import { niortInfo } from "../niort-info";
import { CatNats } from "./sections/CatNats";
import {getCoords} from "../../../../utils/map/geocodingUtils";

export const WidgetNiort = (props) => {
    const [addressInfos, setAddressInfos] = useState(props.addressInfos);
    const [data, setData] = useState(null);
    const [activeSection, setActiveSection] = useState(null);
    const [activeMedia, setActiveMedia] = useState(null);
    const [activeItem, setActiveItem] = useState(null);
    const [scenario, setScenario] = useState(null);

    useEffect(() => {
        if(props.summary){
            let inseeCode = addressInfos.com.com;
            setData(niortInfo.map(section =>
                ({
                    ...section,
                    items: section.items.map(item => item.maps ? {...item, maps: item.maps.map(m => mountFormattedOverlay(m, props.summary))} : item)
                }))
            )
        }
    }, [])

    const initUrl = (menuId, submenuId, scenarioId) => {
        if(menuId && ['risques-naturels', 'risques-technologiques', 'risques-societaux', 'risques-sanitaires', 'catastrophes-naturelles'].includes(menuId)){
            if(submenuId && submenuId == 'crues-a-niort'){
                let validScenario = [125, 150, 170, 190, 225, 260, 290, 320, 360, 420].includes(Number(scenarioId)) ? scenarioId : '125';
                onSelectSection(menuId, 'crues_a_niort', validScenario);
            } else {
                onSelectSection(menuId, submenuId, null);
            }
        } else {
            setActiveSection(niortInfo.find(s => s.id == 'home'))
        }
    }

    const updateAddress = (suggestion) => {
        let address = {};
        if(suggestion){
            getCoords(suggestion).then(coords => {
                let {lat, lon} = coords;

                address = {
                    lat,
                    lon,
                    label: suggestion.properties.label
                }

                setAddressInfos({
                    ...addressInfos,
                    address
                })
            });
        }
    }

    const onSelectSection = (sectionId, selectedItemId, scenario) => {
        if(data){
            let section = data.find(s => s.id == sectionId)
            let item = null;
            if(!['home', 'catastrophes-naturelles'].includes(sectionId)){
                if(selectedItemId && section.items.find(i => i.id === selectedItemId)){
                    item = section.items.find(i => i.id === selectedItemId);
                } else {
                    item = section.items[0];
                }
            }
            setActiveSection(section);
            setActiveItem(item);
            setScenario(scenario ? scenario : null);
        }
    }

    //client-side routing
    const updateUrl = () => {
        if(activeSection){
            let url = new URL(props.baseUrl);
            if(activeSection.id !== 'home'){
                url += `/${activeSection.id}`;
                if(activeItem){
                    url += `/${activeItem.id.replaceAll('_', ('-'))}`;
                    if(scenario){
                        url += `?scenario=${scenario}`;
                    }
                }
            }
            history.pushState({}, "", url);
        }
    }

    //update react according to url change
    window.addEventListener('popstate', () => {
        if(props){
            let url = new URL(window.location.href);
            let urlParams = url.href.split(`${props.baseUrl}/`)[1];
            if(urlParams){
                let paramsSplitted = urlParams.split('/');
                initUrl(paramsSplitted[0], paramsSplitted[1], url.searchParams.get('scenario'));
            }
        }
    });

    useEffect(() => {
        data && initUrl(props.menu, props.submenu, props.scenario)
    }, [data])

    //update url according to react change
    useEffect(() => {
        if(activeSection){
            updateUrl();
        }
    }, [activeSection, activeItem, scenario])

    return (
        <>
        {activeSection &&
            <div className="widget-ville" aria-label="Section contenant une zone avec le menu principal et une zone avec le contenu principal">
                <link rel="preconnect" href="https://fonts.googleapis.com"/>
                <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin/>
                <link href="https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap" rel="stylesheet"/>
                <MenuControls activeSection={activeSection} openSection={onSelectSection}/>
                {activeSection.id === 'home' && <Home data={activeSection} openMedia={(mediaItem) => setActiveMedia(mediaItem)}/>}
                {activeSection.id === 'risques-naturels' && 
                    <NaturalRisks
                        data={activeSection}
                        addressInfos={addressInfos}
                        outlineCity={props.outlineCity}
                        selectedItem={activeItem}
                        scenario={scenario}
                        updateAddress={updateAddress}
                        openMedia={(mediaItem) => setActiveMedia(mediaItem)}
                        onSelectItem={onSelectSection}
                    />
                }
                {activeSection.id === 'risques-technologiques' && 
                    <TechnoRisks
                        data={activeSection}
                        addressInfos={addressInfos}
                        outlineCity={props.outlineCity}
                        selectedItem={activeItem}
                        updateAddress={updateAddress}
                        openMedia={(mediaItem) => setActiveMedia(mediaItem)}
                        onSelectItem={onSelectSection}
                    />
                }
                {activeSection.id === 'risques-societaux' && 
                    <SocietalRisks
                        data={activeSection}
                        selectedItem={activeItem}
                        openMedia={(mediaItem) => setActiveMedia(mediaItem)}
                        onSelectItem={onSelectSection}
                    />
                }
                {activeSection.id === 'risques-sanitaires' &&
                    <SanitaryRisks
                        data={activeSection}
                        selectedItem={activeItem}
                        openMedia={(mediaItem) => setActiveMedia(mediaItem)}
                        onSelectItem={onSelectSection}
                    />
                }
                {activeSection.id === 'catastrophes-naturelles' &&
                    <CatNats 
                        data={activeSection}
                        catnatsList={props.catnatsList}
                        openMedia={(mediaItem) => setActiveMedia(mediaItem)}
                    />
                }
                {activeMedia &&
                    <Modal mediaData={activeMedia} onClose={() => setActiveMedia(null)}/>
                }
            </div>
        }
        </>
    )
}